import { createWebHistory, createRouter } from 'vue-router';
// import { applyMiddlewares, loadMiddlewares } from '@/shared/utils/middlewares';
import { loadRoutes } from '@/shared/utils/routes';

// Get all .routes.ts files within app
const routes = loadRoutes();

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const LAST_ROUTE_KEY = 'last_route';

const AUTH_ROUTE_NAMES = new Set(['login', 'login-reset-password', 'login-two-factor-setup', 'login-two-factor-verify']);

router.beforeEach((to, from) => {
    if (!router.resolve(to)?.matched.length) {
        return {
            name: 'login'
        };
    }

    if (to.meta.title) {
        document.title = to.meta.title as string;
    }

    // Handle modal navigation
    if (to.meta.modal) {
        // Find the parent route by looking at the matched routes (redirect only on refresh/direct link when from is empty)
        if (to.matched.length > 1 && !from.name) {
            const parentRoute = to.matched.findLast(route => !route.meta.modal);
            if (parentRoute && parentRoute.name !== from.name) {
                return {
                    name: parentRoute.name,
                    params: to.params,
                    query: to.query
                };
            }
        }
    }

    return true;
});

router.afterEach((to) => {
    if (!to.meta.modal && to.name && !AUTH_ROUTE_NAMES.has(to.name as string)) {
        localStorage.setItem(LAST_ROUTE_KEY, to.path);
    }
});

// For debugging
// router.beforeEach((to, from, next) => {
//     console.log('[NAVIGATION] from:', from.fullPath, 'to:', to.fullPath, 'via beforeEach');
//     next();
// });

// router.afterEach((to, from) => {
//     console.log('[AFTER EACH] from:', from.fullPath, 'to:', to.fullPath);
// });

// router.onError((err) => {
//     console.warn('[ROUTER ERROR]', err);
// });

// ['push', 'replace'].forEach((method) => {
//     const original = router[method];

//     router[method] = function (...args) {
//         console.log(`🔍 router.${method} called with:`, args);
//         console.trace(`🔍 STACK TRACE for router.${method}`);
//         return original.apply(this, args);
//     };
// });
// const middleware = loadMiddlewares();
// applyMiddlewares(router, middleware);

export { router };
